// extracted by mini-css-extract-plugin
module.exports = {"faqCategory":"styles_faqCategory__Iue2G","categoryTitle":"styles_categoryTitle__k-wsX","itemContainer":"styles_itemContainer__2MCfO"};